/**
 * FooterAnchor - footer dark anchor (Editorial Authority S10, analogue TR
 * footer dark green #123021). REUSE VERBATIM disclaimer LEGAL-TEMPLATE-HASH
 * tu footer.tsx (legal-upl HARD - cam sua wording).
 */
import { Link } from 'react-router-dom';
import type { Lang } from '../../use-lang';
import type { LandingCopy } from '../../i18n/landing-editorial';
import {
  DISCLAIMER_EN,
  DISCLAIMER_VN,
  IMG_AI_NOTE_EN,
  IMG_AI_NOTE_VN,
  VOICE_STATEMENT_EN,
  VOICE_STATEMENT_VN,
} from '../footer';

export function FooterAnchor({ lang, copy }: { lang: Lang; copy: LandingCopy }) {
  const voice = lang === 'vi' ? VOICE_STATEMENT_VN : VOICE_STATEMENT_EN;
  const disclaimer = lang === 'vi' ? DISCLAIMER_VN : DISCLAIMER_EN;
  const imgNote = lang === 'vi' ? IMG_AI_NOTE_VN : IMG_AI_NOTE_EN;
  const copyright = lang === 'vi' ? '(c) Asklaw - Sinh bởi AI Asklaw' : '(c) Asklaw - Generated by Asklaw AI';
  return (
    <footer className="ed-footer" role="contentinfo">
      <div className="ed-container">
        <div className="ed-footer__cols">
          {copy.footer_cols.map((col) => (
            <div className="ed-footer__col" key={col.heading}>
              <h3>{col.heading}</h3>
              <ul>
                {col.links.map((l) => (
                  <li key={l.to + l.label}>
                    <Link to={l.to}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="ed-footer__legal">
          <p><strong>{voice}</strong></p>
          <p>{disclaimer}</p>
          <p>
            {lang === 'vi' ? 'Kiểm tra văn bản gốc tại ' : 'Verify source documents at '}
            <a href="https://vbpl.vn" rel="noopener noreferrer" target="_blank">vbpl.moj.gov.vn</a>
            {' | DPO: '}
            <a href="mailto:dpo@asklaw.vn">dpo@asklaw.vn</a>
          </p>
          <p>{imgNote}</p>
          <p>{copyright}</p>
        </div>
      </div>
    </footer>
  );
}
